import { alpha } from '@mui/material/styles';

// ==============================|| OVERRIDES - TABLE BODY ||============================== //

export default function TableBody(theme) {
  const hoverStyle = {
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.07)
    }
  };

  return {
    MuiTableBody: {
      styleOverrides: {
        root: {
          '&.striped .MuiTableRow-root': {
            '&:nth-of-type(even)': {
              backgroundColor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.05 : 0.025)
            },
            ...hoverStyle
          },
          '& .MuiTableRow-root': {
            '&:nth-of-type(even)': {
              backgroundColor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.05 : 0.025)
            },
            ...hoverStyle
          }
        }
      }
    }
  };
}
